module.exports = __webpack_public_path__ + "static/home1-welcome-text-34ba2e973405a8f2b6dce8d58ea78a96.png";